module.exports = __webpack_public_path__ + "static/media/LogoGoogle.4eee28e4.png";